import { useEffect, useRef } from 'react'
import Title from '../shared/Title'
import { useIntersectionObserver } from '../../hooks/useIntersectionObserver'

const Features = () => {
  const [featuresRef, isVisible] = useIntersectionObserver()
  const cardsRef = useRef([])

  useEffect(() => {
    const cards = cardsRef.current
    if (!cards.length) return

    const handleHover = (e, card, index) => {
      const { clientX, clientY } = e
      const cardRect = card.getBoundingClientRect()
      
      const x = clientX - cardRect.left - cardRect.width / 2
      const y = clientY - cardRect.top - cardRect.height / 2
      
      // Calculate rotation and movement
      const multiplier = 25
      const rotateX = -y / cardRect.height * multiplier
      const rotateY = x / cardRect.width * multiplier
      
      card.style.transform = `
        perspective(1000px)
        rotateX(${rotateX}deg)
        rotateY(${rotateY}deg)
        scale3d(1.05, 1.05, 1.05)
      `
      
      // Move icon
      const icon = card.querySelector('.feature-card__icon')
      if (icon) {
        icon.style.transform = `
          translate(${x/8}px, ${y/8}px)
          rotate(${(x + y)/20}deg)
        `
      }
    }

    const resetCard = (card) => {
      card.style.transform = ''
      const icon = card.querySelector('.feature-card__icon')
      if (icon) {
        icon.style.transform = ''
      }
    }

    cards.forEach((card, index) => {
      if (card) {
        card.addEventListener('mousemove', (e) => handleHover(e, card, index))
        card.addEventListener('mouseleave', () => resetCard(card))
      }
    })

    return () => {
      cards.forEach((card) => {
        if (card) {
          card.removeEventListener('mousemove', handleHover)
          card.removeEventListener('mouseleave', resetCard)
        }
      })
    }
  }, [])

  const features = [
    {
      image: "https://picsum.photos/seed/rays-reunion/400/300",
      icon: "🤝",
      title: "Reunions & Gatherings",
      description: "Regular meet-ups and annual reunions to celebrate our shared bonds and create new memories."
    },
    {
      image: "https://picsum.photos/seed/rays-career/400/300",
      icon: "🎯",
      title: "Career Compass",
      description: "Mentorship programs connecting experienced alumni with younger Rajagirians for career guidance."
    },
    {
      image: "https://picsum.photos/seed/rays-network/200/200",
      title: "Professional Networking",
      description: "Connect with alumni across industries for career opportunities and collaborations."
    },
    {
      image: "https://picsum.photos/seed/rays-advantage/200/200",
      title: "Alumni Advantage",
      description: "Exclusive webinars and workshops led by alumni experts on various professional topics."
    }
  ]

  return (
    <section id="features" className="features" ref={featuresRef}>
      <div className="features__background">
        <div className="features__blob"></div>
        <div className="features__grid-pattern"></div>
      </div>
      
      <div className="container">
        <Title 
          tagline="What We Do"
          heading="RAYS Features"
          subheading="Empowering our alumni community"
          animate={isVisible}
        />
        
        <div className="features__grid">
          {features.map((feature, index) => (
            <div 
              key={index}
              ref={el => cardsRef.current[index] = el}
              className={`feature-card animate slide-up ${isVisible ? 'visible' : ''}`}
              style={{ animationDelay: `${0.1 * (index + 3)}s` }}
            >
              <div className="feature-card__inner">
                <div className="feature-card__image">
                  <img src={feature.image} alt={feature.title} />
                  <div className="feature-card__overlay"></div>
                </div>
                <div className="feature-card__content">
                  {feature.icon && (
                    <span className="feature-card__icon">{feature.icon}</span>
                  )}
                  <h3>{feature.title}</h3>
                  <p>{feature.description}</p>
                </div>
                <div className="feature-card__shine"></div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default Features 